import { DemoGameDetails } from '../page/DemoGameDetails/DemoGameDetails'

export default DemoGameDetails
